import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "AA Mock Portal": {
    parameters: {
      linkUrls: ["https://www.google.com"],
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "AA" as any,
  },
};
